import React, { createContext, useContext } from 'react';
import { useAdminNotifications } from '../hooks/useAdminNotifications';
import type { AdminNotification } from '../services/firebaseFunctions';

interface AdminNotificationsContextType {
  notifications: AdminNotification[];
  loading: boolean;
  error: string | null;
  resolveNotification: (id: string) => Promise<void>;
  reload: () => Promise<void>;
}

const AdminNotificationsContext = createContext<AdminNotificationsContextType | undefined>(undefined);

export const useAdminNotificationsContext = (): AdminNotificationsContextType => {
  const ctx = useContext(AdminNotificationsContext);
  if (ctx === undefined) {
    throw new Error('useAdminNotificationsContext must be used within AdminNotificationsProvider');
  }
  return ctx;
};

interface AdminNotificationsProviderProps {
  children: React.ReactNode;
}

export const AdminNotificationsProvider: React.FC<AdminNotificationsProviderProps> = ({ children }) => {
  const value = useAdminNotifications();
  return (
    <AdminNotificationsContext.Provider value={value}>
      {children}
    </AdminNotificationsContext.Provider>
  );
};
